import values from 'lodash/values';
import { call, put, select } from 'redux-saga/effects';

import * as PlaylistActions from '../../actions';
import * as D from '../../deps';
import * as PlaylistServices from '../../services';

export function* getAndAddReplayTrack(action) {
  const { sourceId, track, playlistIndex } = action.data;
  const audioFormat = yield select(D.Utils.Listener.getCurrentListenerDefaultAudioFormat);
  const currentTrackToken = yield select(D.PlaybackUtils.getCurrentTrackTokenFromActivePlaylist);
  let trackToken = D.Utils.Core.getFromMap(track, 'trackToken');
  const artistUid = D.Utils.Core.getFromMap(track, 'artistMessage', 'artistUid');
  const response = yield call(PlaylistServices.getReplayTrack, {
    stationId: sourceId,
    trackToken,
    audioFormat,
    artistUid,
  });
  trackToken = values(response.entities.playlistTracks)[0].trackToken;

  yield put(
    PlaylistActions.insertTrackIntoPlaylist({
      playlist: sourceId,
      index: playlistIndex,
      currentTrackToken,
      trackToken,
      audioFormat,
    }),
  );
}
